/* QUICK ADD */
function initializeVariantButtons(container) {
  const variantButtons = container.querySelectorAll(".variant-button");
  const selectedVariantInput = container.querySelector("#selectedVariantId");

  variantButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      let quickAddSheet = document.getElementById("quickAddSheet");
      const selectedOption = button.getAttribute("data-variant-id");
      if (button.disabled) {
        e.preventDefault();
        alert("This variant is unavailable");
        return;
      }

      const loadingSpinner = button.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
      }

      if (selectedVariantInput) {
        selectedVariantInput.value = selectedOption;
        if (quickAddSheet) {
          quickAddSheet.classList.add("hidden");
        }
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
  hideOnAdd();
}

function hideOnAdd() {
  console.log("teste");
  
  const addButton = document.querySelectorAll("#quickAddSheet .op__container .quick-add__submit");

  addButton.forEach((button) => {
    if (button) {
      button.addEventListener("click", () => {
        console.log("teste");
        const quickAddSheet = document.getElementById("quickAddSheet");
        if (quickAddSheet) {
          quickAddSheet.classList.add("hidden");
          document.body.classList.remove("overflow-hidden");
        } else {
          console.warn("quickAddSheet not found");
        }
      });
    } else {
      console.warn("No buttons found");
    }
  });

  if (addButton.length === 0) {
    console.warn("No buttons were added");
  }
}

function updateQuickAddVariants(quickAddContainer, variantData) {
  const variantButtons = quickAddContainer.querySelectorAll(".variant-button");

  if (variantButtons.length !== variantData.length) {
    console.warn("Mismatch between variant buttons and variant data.");
    return;
  }
  variantButtons.forEach((button, index) => {
    const variant = variantData[index];
    console.log(`Button ${index} associated with variant ID:`, variant.id);

    button.setAttribute("data-variant-id", variant.id);
    button.setAttribute("aria-disabled", !variant.available);

    if (variant.available) {
      button.classList.remove("disabled");
    } else {
      button.classList.add("disabled");
    }

    const span = button.querySelector("span");
    if (span) {
      span.textContent = variant.title;
    }
  });
  initializeVariantButtons(quickAddContainer);
}

function variantImages() {
  document.querySelectorAll(".product-card-wrapper").forEach((cardWrapper) => {
    const principalMediaContainer = cardWrapper.querySelector(
      ".card__inner .media"
    );
    const variationSwatches = cardWrapper.querySelectorAll(
      ".product_variant__swatch"
    );
    if (principalMediaContainer) {
      const originalImage = principalMediaContainer.innerHTML;
    
      let isImageChanged = false;

      function resetImage() {
        if (isImageChanged) {
          principalMediaContainer.innerHTML = originalImage;
          isImageChanged = false;
        }
      }


    variationSwatches.forEach((swatch) => {
      swatch.addEventListener("click", function (event) {
        event.stopPropagation();
        principalMediaContainer.innerHTML = "";

        const newImage = swatch.querySelector(".image-cards img");
        if (newImage) {
          const clonedImg = newImage.cloneNode(true);
          principalMediaContainer.appendChild(clonedImg);
          isImageChanged = true;
        }

        const container = cardWrapper.querySelector(".op__container");
        if (container) {
          const scriptData = swatch.querySelector(".product-list-json");
          const variantData = JSON.parse(scriptData.textContent);

          updateQuickAddVariants(container, variantData);
        }
      });

      cardWrapper.addEventListener("click", function (event) {
        if (
          !event.target.closest(".product_variant__swatch") &&
          !event.target.closest(".quick-add")
        ) {
          resetImage();
        }
      });
    });
   }
  });
}

function handleMobileSheet(button) {
  const parentContainer = button.closest(".quick-add__container");
  const dropdown = parentContainer.querySelector(
    ".quick-add__dropdown"
  ).innerHTML;

  let quickAddSheet = document.getElementById("quickAddSheet");
  if (!quickAddSheet) {
    quickAddSheet = document.createElement("div");
    quickAddSheet.id = "quickAddSheet";
    quickAddSheet.className = "quick-add__sheet hidden";

    quickAddSheet.innerHTML = `
        <div class="quick-add__sheet-content">
          <span class="close__bar medium-hide large-up-hide close-mobile-btn"></span>
          <div class="quick-add__container"></div>
        </div>
      `;

    document.body.appendChild(quickAddSheet);

    quickAddSheet.addEventListener("click", (event) => {
      if (event.target === quickAddSheet) {
        quickAddSheet.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      }
    });

    const detailsCloseButton = quickAddSheet.querySelector(".close-mobile-btn");

    if (detailsCloseButton) {
      detailsCloseButton.addEventListener("click", () => {
        quickAddSheet.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      });
    }
  }

  const sheetContainer = quickAddSheet.querySelector(".quick-add__container");
  sheetContainer.innerHTML = dropdown;
  initializeVariantButtons(sheetContainer);

  quickAddSheet.classList.remove("hidden");
  document.body.classList.add("overflow-hidden");
}

function handleDesktopOverlay(button) {
  const parentContainer = button.closest(".quick-add__container");
  const dropdown = parentContainer.querySelector(".quick-add__dropdown");

  // Toggle the active class
  const isActive = dropdown.classList.contains("active");
  dropdown.classList.toggle("active", !isActive);

  // Update the aria-expanded attribute
  button.setAttribute("aria-expanded", !isActive);
}

function handleQuickAdd() {
  const quickAddButtons = document.querySelectorAll(".quick-add__submit");

  quickAddButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const isMobile = window.matchMedia("(max-width: 990px)").matches;

      if (isMobile) {
        handleMobileSheet(button);
      } else {
        handleDesktopOverlay(button);
      }
    });
  });

  // Close other dropdowns when one is clicked (optional)
  document.addEventListener("click", (event) => {
    const clickedButton = event.target.closest(".quick-add__submit");

    if (!window.matchMedia("(max-width: 990px)").matches) {
      document
        .querySelectorAll(".quick-add__dropdown.active")
        .forEach((dropdown) => {
          const parentContainer = dropdown.closest(".quick-add__container");
          const button = parentContainer.querySelector(".quick-add__submit");

          // If the clicked element is not the current button, close the dropdown
          if (clickedButton !== button) {
            dropdown.classList.remove("active");
            button.setAttribute("aria-expanded", "false");
          }
        });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  variantImages();
  handleQuickAdd();
  document.querySelectorAll(".quick-add__container").forEach((container) => {
    initializeVariantButtons(container);
  });
  hideOnAdd();
});

document.querySelector(".load-more-button")?.addEventListener("click", () => {
  const productGrid = document.getElementById("product-grid");
  const observer = new MutationObserver((mutationList, observerInstance) => {
    const newItems = mutationList.some(
      (mutation) => mutation.addedNodes.length > 0
    );

    if (newItems) {
      variantImages();
    }
  });

  observer.observe(productGrid, {
    childList: true,
    subtree: false,
  });
  /* observerInstance.disconnect(); */
});